import { observer } from "mobx-react";
import React from "react";
import { NavLink } from "react-router-dom";

function NotificationsCenterNavigation() {
  return (
    <div className="settings-links-wrap">
      <ul>
        <li>
          <NavLink to="/notifications/reviews">Review Items</NavLink>
        </li>
      </ul>
    </div>
  );
}

export default observer(NotificationsCenterNavigation);
